import cn from "classnames";

import Typography from "@mui/material/Typography";

import { StrapiComponentType } from "@/src/type";

import { TextModule } from "../component";

import styles from "./UnitDetails.module.scss";

interface UnitDetailsFactsProps {
  unit: StrapiComponentType.Partial.UnitTypeDetail;
  showAllFacts?: boolean;
}

function UnitDetailsFacts({ unit, showAllFacts }: UnitDetailsFactsProps) {
  return (
    <>
      <Typography
        variant={"body1"}
        className={styles.title}
      >
        {unit.title}
      </Typography>
      <div className={styles.sizeContainer}>
        {unit?.sqFt && (
          <Typography
            variant={"body1"}
            className={cn(styles.sizing, styles.bold)}
          >
            {unit.sqFt}
          </Typography>
        )}
        {unit?.sqFt && unit?.sqM && (
          <Typography
            variant={"body1"}
            className={styles.sizing}
          >
            |
          </Typography>
        )}
        {unit?.sqM && (
          <Typography
            variant={"body1"}
            className={cn(styles.sizing, styles.extra)}
          >
            {unit.sqM}
          </Typography>
        )}
      </div>
      {(unit.facts ?? []).length > 0 && (
        <div className={cn(styles.facts, showAllFacts ? styles.off : undefined)}>
          {(unit.facts ?? []).map((fact, f) => (
            <TextModule
              key={f}
              className={cn(styles.sizing, styles.small)}
              text={fact}
            />
          ))}
        </div>
      )}
    </>
  );
}

export default UnitDetailsFacts;
